import { Button, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useResolvedLabel } from '../hooks/useResolvedLabel';

import { ICON_BY_CHANNEL } from './constants';
import { useRoundShareIconButton } from './hooks/useRoundShareIconButton';
import type { RoundShareIconButtonConfig } from './types';

export type { RoundShareIconButtonChannel, RoundShareIconButtonConfig, TranslatableLabel } from './types';

type Props = {
	buttonConfig: RoundShareIconButtonConfig;
	className?: string;
	onBeforeShare?: () => void;
};

export const RoundShareIconButton = ({
	buttonConfig: { ShareAction, label, channel, successLabel },
	className,
	onBeforeShare,
	...rest // for data attributes
}: Props): React.JSX.Element => {
	const IconComponent = ICON_BY_CHANNEL[channel];
	const { data, actions } = useRoundShareIconButton({ label, successLabel });
	const ariaLabel = useResolvedLabel(label);
	const buttonLabel = useResolvedLabel(data.buttonLabel);
	return (
		<ShareAction onBeforeAction={onBeforeShare} onAfterAction={actions.afterShare}>
			<Button
				aria-label={ariaLabel}
				data-testid={`${channel}-share-button`}
				variant="tertiary"
				className={cn(
					'p-0 no-underline [&>div]:flex [&>div]:flex-col [&>div]:items-center [&>div]:justify-center',
					className,
				)}
				{...rest}
			>
				<div className="mt-[5px] flex h-10 w-10 flex-col items-center rounded-full bg-transparent px-0 pb-0">
					{IconComponent}
				</div>
				<Text className="mt-1 block w-full truncate text-xs leading-6">{buttonLabel}</Text>
			</Button>
		</ShareAction>
	);
};
